
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-.083 16.273a.866.866 0 00-.866.866.866.866 0 00.866.866H16.09a.866.866 0 00.866-.866.866.866 0 00-.866-.866zM12.764.003a2.91 2.91 0 00-2.062.848L5.364 6.19c-.029.03-.049.064-.075.093a.866.866 0 00-.005.002.866.866 0 00-.317.402l-1.819 4.716a.866.866 0 001.12 1.12l4.717-1.817a.866.866 0 00.399-.314c.032-.028.07-.051.1-.081l5.34-5.338a2.928 2.928 0 000-4.123 2.904 2.904 0 00-2.06-.848zm0 1.721c.3 0 .6.118.835.353a1.17 1.17 0 010 1.671l-5.341 5.34a.277.277 0 01-.41 0l-1.26-1.262a.277.277 0 010-.409l5.339-5.34a1.18 1.18 0 01.837-.353zM5.762 9.448l.465.464-.756.291z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    